<template>
  <div>
    <vxe-card>
      <template #title>
        <vxe-button :content="$t('business.label.reviewer')+$t('business.label.config')" mode="text" status="primary"/>
      </template>
      <template #extra>
        <vxe-button content="button.refresh" icon="vxe-icon-refresh" mode="text" status="danger" @click="fetch()"/>
        <vxe-button content="button.add" icon="vxe-icon-add" mode="text" status="primary" @click="add"/>
        <vxe-button content="button.save" icon="vxe-icon-save" mode="text" status="primary" @click="save"/>
      </template>
      <vxe-table ref="table" :data="data" :edit-config="{}" :loading="loading" keep-source>
        <vxe-column fixed="left" type="seq" width="40"/>
        <vxe-column field="reviewer.name" title="business.label.reviewer" width="200"/>
        <vxe-column :edit-render="applicationRender" field="application" title="business.label.application" width="200"/>
        <vxe-column :edit-render="{name:'VxeNumberInput',autoSelect:true}" field="ordinal" title="business.label.ordinal" width="100"/>
        <vxe-column :edit-render="ownerRender" field="owner.name" title="business.label.owner"/>
        <vxe-column :edit-render="orderTypeRender" field="orderType.name" title="business.label.orderType"/>
        <vxe-column :edit-render="pickupModeRender" field="pickupMode.id" title="business.label.pickupMode"/>
        <vxe-column :edit-render="directionRender" field="direction.id" title="business.label.direction"/>
        <vxe-column :cell-render="{name:'VxeSwitch'}" field="available" title="business.label.available" width="70"/>
        <vxe-column fixed="right" title="business.label.operate" width="auto">
          <vxe-button-group slot-scope="{row}" mode="text">
            <vxe-button content="button.delete" icon="vxe-icon-delete" status="danger" @click.stop="remove(row)"/>
          </vxe-button-group>
        </vxe-column>
      </vxe-table>
    </vxe-card>
    <customer-modal ref="ownerModal" title="business.label.owner" @change="(values,row)=>onInputChange(row,'owner',values[0])"/>
    <order-type-modal ref="orderTypeModal" @change="(values,row)=>onInputChange(row,'orderType',values[0])"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { WAREHOUSE } from '@/store/mutation-types'
import { deleteOne, findAll, saveAll } from '@/api/Api'
import { User } from '@/api/dto/common/User'
import { ReviewerConfig } from '@/api/dto/config/ReviewerConfig'
import CustomerModal from '@/views/modal/CustomerModal.vue'
import OrderTypeModal from '@/views/modal/OrderTypeModal.vue'
import { onInputChange } from '@/utils/util'

export default {
  name: 'ReviewerTable',
  components: { CustomerModal, OrderTypeModal },
  props: {
    applications: { type: Array, default: [] },
    pickupModes: { type: Array, default: [] },
    directions: { type: Array, default: [] }
  },
  data() {
    return {
      warehouse: Vue.ls.get(WAREHOUSE),
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      reviewer: new User(),
      applicationRender: {
        name: 'VxeSelect',
        options: this.applications
      },
      ownerRender: {
        name: 'VxeInput',
        events: {
          click: ({ row }) => this.$refs.ownerModal.open({ available: true, 'type.ordinal': 1 }, row),
          clear: ({ row }) => this.onInputChange(row, 'owner')
        }
      },
      orderTypeRender: {
        name: 'VxeInput',
        events: {
          click: ({ row }) => this.$refs.orderTypeModal.open({ available: true, operationType: 2 }, row),
          clear: ({ row }) => this.onInputChange(row, 'orderType')
        }
      },
      pickupModeRender: {
        name: 'VxeSelect',
        options: this.pickupModes
      },
      directionRender: {
        name: 'VxeSelect',
        options: this.directions
      }
    }
  },
  methods: {
    onInputChange,
    fetch(user) {
      this.loading = true
      if (user) {
        this.reviewer = user
      }
      findAll('reviewerConfigFactory', { 'reviewer.id': this.reviewer.id }).then(res => {
        if (res.success) {
          this.data = res.result.map(item => {
            return new ReviewerConfig(item)
          })
        }
      }).finally(() => this.loading = false)
    },
    add() {
      const config = new ReviewerConfig()
      config.available = true
      config.reviewer = this.reviewer
      this.data.push(config)
    },
    async save() {
      const errMap = await this.$refs.table.validate(true)
      if (errMap) {
        return
      }
      let saveData = this.$refs.table.getUpdateRecords().concat(this.$refs.table.getInsertRecords())
      if (saveData.length > 0) {
        this.loading = true
        saveData = saveData.map(item => {
          item.warehouse = this.warehouse
          return item.toJSONObject()
        })
        saveAll('reviewerConfigPersister', saveData).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success(this.$t('message.saveSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.$message.warning('无数据可保存')
      }
    },
    remove(row) {
      if (row.id) {
        this.loading = true
        deleteOne('reviewerConfigDeleter', { id: row.id }).then(res => {
          if (res.success) {
            this.fetch()
            this.$message.success(this.$t('message.deleteSuccess'))
          }
        }).finally(() => this.loading = false)
      } else {
        this.data.splice(this.data.indexOf(row), 1)
      }
    }
  }
}
</script>